const allRegions = [
  'The Westerlands',
  'Dorne',
  'The North',
  'The Reach',
  'The Vale',
  'The Riverlands',
  'The Crownlands',
  'The Stormlands',
  'The Neck',
  'Iron Islands',
  'Beyond the Wall',
  'None',
];

export { allRegions };
